export default __webpack_public_path__ + "static/media/snow.81c4c28d.svg";